import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
    // On récupère le chemin actuel de l'URL (ex: "/newjeansNeverDie")
    const { pathname } = useLocation();

    // À chaque fois que le pathname change, on déclenche cet effet
    useEffect(() => {
        // Force le navigateur à remonter aux coordonnées (X: 0, Y: 0)
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant" // Force l'instantanéité
        });
    }, [pathname]);

    // Ce composant n'affiche rien visuellement
    return null; 
}